import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="relative bg-slate-950 border-t border-slate-900 py-12 px-6"
      data-component-path="client/src/components/Footer.jsx"
      data-component-line="1:5"
      data-component-id="client/src/components/Footer.jsx:1:5"
    >
      <div 
        className="max-w-6xl mx-auto"
        data-component-path="client/src/components/Footer.jsx"
        data-component-line="2:7"
        data-component-id="client/src/components/Footer.jsx:2:7"
      >
        <div 
          className="flex flex-col items-center gap-8"
          data-component-path="client/src/components/Footer.jsx"
          data-component-line="3:9"
          data-component-id="client/src/components/Footer.jsx:3:9"
        >
          {/* Brand */}
          <div 
            className="text-center"
            data-component-path="client/src/components/Footer.jsx"
            data-component-line="4:11"
            data-component-id="client/src/components/Footer.jsx:4:11"
          >
            <h3 
              className="text-2xl font-bold text-slate-100 tracking-tight"
              data-component-path="client/src/components/Footer.jsx"
              data-component-line="5:13"
              data-component-id="client/src/components/Footer.jsx:5:13"
            >
              grYp Gear
            </h3>
            <p 
              className="text-sm text-slate-500 mt-2"
              data-component-path="client/src/components/Footer.jsx"
              data-component-line="6:13"
              data-component-id="client/src/components/Footer.jsx:6:13"
            >
              © {currentYear} grYp Gear. All rights reserved.
            </p>
          </div>
        </div>

        {/* Tagline */}
        <div 
          className="mt-8 pt-8 border-t border-slate-900 text-center"
          data-component-path="client/src/components/Footer.jsx"
          data-component-line="7:9"
          data-component-id="client/src/components/Footer.jsx:7:9"
        >
          <p 
            className="text-sm text-slate-600 font-light tracking-wide"
            data-component-path="client/src/components/Footer.jsx"
            data-component-line="8:11"
            data-component-id="client/src/components/Footer.jsx:8:11"
          >
            Feel the ground. Move naturally. Live connected.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;